<template>
  <div class="collar">
    <!-- “collar”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
      @changeGoodsType="changeGoodsType"
      @projectChange="projectChange"
      @periodChange="periodChange"
      @productCodeChange="productCodeChange"
    ></sirui-search>
    <!-- collar -->
    <div class="main-content">
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{ this.$t('collarDetailsList.column.productCountTotal') }}
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="productCountTotal" :disabled="true"> </el-input>
          </div>
        </el-col>
      </el-row>

      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'goodsType'">
              <dict-span dictType="productType" v-model="scope.row[item.field]"></dict-span>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>

    <el-dialog
      :title="this.$t('collarDetailsList.form.importPeriodNameSelect')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="350px"
    >
      <base-form
        v-model="baseData"
        :options="options"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="100px"
      ></base-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="handleImport()">{{
          $t('dialog.confirm')
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getData"
      ref="siruiUpload"
    >
    </sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/collarDetails.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import siruiUpload from '@/components/SiruiUpload';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  import DictSpan from '@/components/DictSpan';
  import baseForm from '@/components/form/base-form';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'collarDetailsList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      siruiUpload,
      DictSpan,
      baseForm,
    },

    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      baseUrl() {
        return baseUrl;
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   公司代码
          {
            name: this.$t('collarDetailsList.column.recipientsCompanyCode'),
            prop: 'recipientsCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
          },
          //   事业部门
          {
            prop: 'recipientsDepartmentCode',
            name: this.$t('collarDetailsList.column.recipientsDepartmentCode'),
            type: 'select',
            placeholder: this.$t('collarDetailsList.column.recipientsDepartmentCodePlaceholder'),
            options: this.slipDepartmentList,
            clearable: true,
          },
          //业务员
          {
            type: 'searchTableSpec',
            prop: 'createPersonNo',
            isMultiple: true,
            name: this.$t('collarDetailsList.column.createPersonNo'),
            searchType: 'personnel',
            clearable: true,
          },
          {
            // 结算周期
            prop: 'periodName',
            name: this.$t('collarDetailsList.column.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.query.projectCode,
            },
            currentValue: this.query.periodName,
            changeMethod: 'periodChange',
          },
          //供应商
          {
            type: 'input',
            name: this.$t('collarDetailsList.column.partnerCode'),
            prop: 'partnerCode',
            clearable: true,
          },
          // 创建日期
          {
            prop: 'createDateStart',
            name: this.$t('collarDetailsList.column.createDateStart'),
            type: 'startDaterangePicker',
            clearable: true,
          },
          {
            prop: 'createDateEnd',
            name: this.$t('collarDetailsList.column.createDateEnd'),
            type: 'endDaterangePicker',
            clearable: true,
          },
          //商品大类
          {
            prop: 'goodsType',
            name: this.$t('collarDetailsList.column.goodsType'),
            type: 'dict',
            dictType: 'product_type',
            // changeMethod: "changeGoodsType",
            clearable: true,
          },
          //商品编号
          {
            prop: 'productName',
            name: this.$t('collarDetailsList.column.productName'),
            type: 'searchTableSpec',
            searchType: 'produceProduct',
            changeMethod: 'productCodeChange',
            isMultiple: true,
            extraData: {
              productClass: '0',
            },
            //options: this.productDetailList
          },
          /* {
          prop: "productCode",
          name: this.$t("collarDetailsList.column.productCode"),
          type: "select",
          options: this.productDetailList,
          clearable: true
        }, */
          // 出库日期
          {
            prop: 'outboundDateStart',
            name: this.$t('collarDetailsList.column.outboundDateStart'),
            type: 'startDaterangePicker',
            clearable: true,
          },
          {
            prop: 'outboundDateEnd',
            name: this.$t('collarDetailsList.column.outboundDateEnd'),
            type: 'endDaterangePicker',
            clearable: true,
          },
          // 出库仓库
          {
            type: 'searchTableSpec',
            name: this.$t('collarDetailsList.column.storageCode'),
            prop: 'storageCode',
            searchType: 'warehouse',
            isMultiple: true,
            clearable: true,
          },
          // 回单号
          {
            name: this.$t('collarDetailsList.column.receiptNo'),
            prop: 'registerCompanyCode',
            type: 'input',
            clearable: true,
          },
          // 领用数量
          {
            name: this.$t('collarDetailsList.column.productCount'),
            prop: ['productCountCondition', 'productCount'],
            type: 'selectInput',
            inputType: 'inputNumber',
            options: this.productCountConditionList,
            placeholder: this.$t('collarDetailsList.column.productCount'),
            clearable: true,
          },
          //  明细标示
          {
            prop: 'detailLabel',
            name: this.$t('collarDetailsList.column.detailLabel'),
            type: 'select',
            clearable: true,
            options: this.identification,
          },
          {
            // 项目名称
            prop: 'projectCode',
            name: this.$t('collarDetailsList.column.projectName'),
            type: 'dict',
            dictType: 'produce_product_proname',
            changeMethod: 'projectChange',
          },
        ];
      },
      options() {
        return [
          {
            // 账期
            prop: 'periodName',
            label: this.$t('collarDetailsList.label.periodName'),
            type: 'searchTable',
            searchType: 'pdPeriod',
            required: true,
            isMultiple: true,
            span: 18,
            extraData: {
              projectCode: this.baseData.projectCode,
              periodStatus: 'opened',
            },
            currentValue: this.baseData.periodName,
          },
        ];
      },
    },
    data() {
      return {
        dialogAdd: false,
        loading: false,
        importData: {}, // 导入参数
        importUrl: '', // 导入地址
        query: {
          recipientsCompanyCode: '', //公司信息
          recipientsDepartmentCode: '', //部门信息
          createPersonNo: '', //操作人
          partnerCode: '', //供应商
          createDateStart: '', //创建日期起
          createDateEnd: '', //创建日期止
          goodsType: '', //商品大类
          productCode: '', //商品编码
          outboundDateStart: '', //出库日期起
          inboundEndDate: '', //出库日期止
          outboundDateEnd: '', //出库仓库
          registerCompanyCode: '', //回单号
          productCountCondition: '', //商品数量条件
          productCount: undefined, //商品数量
          detailLabel: '', //明细标识
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //账期编码
          periodName: null, //账期
        },
        baseData: {
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //账期编码
          periodName: null, //账期
          outboundType: null, //导出出库类型
        },
        tableData: [], //列表数据
        companyList: [], // 公司
        slipDepartmentList: [], // 部门
        productDetailList: [], //商品编号
        multipleSelection: [], //选中数据
        productCountTotal: 0,
        identification: [
          // 明细标示
          {
            label: this.$t('collarDetailsList.column.redBack'),
            value: this.$t('collarDetailsList.column.redBack'),
          },
        ],
        productCountConditionList: [
          // 商品数量条件
          { value: 1, label: this.$t('collarDetailsList.search.equal') }, //等于
          { value: 2, label: this.$t('collarDetailsList.search.notEqual') }, //不等于
          { value: 3, label: this.$t('collarDetailsList.search.gt') }, //大于
          { value: 4, label: this.$t('collarDetailsList.search.lt') }, //小于
        ],
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          // { type: "seq", visible: true, width: "50", fixed: "left", title: "table.index" },
          {
            field: 'goodsType',
            title: 'collarDetailsList.column.goodsType',
            visible: true,
            width: 80,
            dictType: 'productType',
          },
          //原料编码
          {
            field: 'productCode',
            title: this.$t('collarDetailsList.column.productCode'),
          },
          {
            field: 'productName',
            title: 'collarDetailsList.column.productName',
            visible: true,
            width: 120,
          },
          //账期名称
          {
            field: 'periodName',
            title: this.$t('collarDetailsList.column.periodName'),
          },
          {
            field: 'partnerName',
            title: 'collarDetailsList.column.partnerName',
            visible: true,
          },
          {
            field: 'productCount',
            title: 'collarDetailsList.column.productCount',
            visible: true,
          },
          {
            field: 'receiptNo',
            title: 'collarDetailsList.column.receiptNo',
            visible: true,
          },
          {
            field: 'storageName',
            title: 'collarDetailsList.column.storageCode',
            visible: true,
          },
          {
            field: 'outboundDate',
            title: 'collarDetailsList.column.outboundDate',
            visible: true,
          },
          {
            field: 'detailLabel',
            title: 'collarDetailsList.column.detailLabel',
            visible: true,
          },
          {
            field: 'createPersonName',
            title: 'collarDetailsList.column.createPersonName',
            visible: true,
          },
          {
            field: 'recipientsDepartmentName',
            title: 'collarDetailsList.column.recipientsDepartmentName',
            visible: true,
          },
          {
            field: 'recipientsCompanyName',
            title: 'collarDetailsList.column.recipientsCompanyName',
            visible: true,
          },
        ],
      };
    },
    mounted() {
      //this.getData();
      this.getCompany();
      this.getButtonList();
      this.setImport(), this.getCurrentDepartment();
      this.$nextTick(() => {
        //设置导入参数
        this.setImport();
      });
    },
    methods: {
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getCurrentDepartment();
      },
      async getCompany() {
        // 公司
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      // 获取列表数据
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        this.query.createPersonNo =
          this.query.createPersonNo && this.query.createPersonNo[0]
            ? this.query.createPersonNo[0].id
            : '';
        if (!this.query.periodName) {
          return this.tips('noPeriodName', 'error');
        }
        const params = { ...this.query, pageNum, pageSize };
        this.load = true;
        this.$axios.post(API.COLLARDETAILS_LIST_API, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.pageList.records;
            this.productCountTotal = res.data.data.productCountSum;
            this.$refs.siruiTable.setPageTotal(res.data.data.pageList.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      productCodeChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.productCode = res[0].productCode;
          this.query.productName = res[0].productName;
        } else {
          this.query.productCode = null;
          this.query.productName = null;
        }
      },
      //切换公司
      changeCompany(val) {
        // this.slipDepartmentList = [];
        this.query.recipientsDepartmentCode = null;
        /* this.companyList.find(item => {
        if (item.value === val.val) {
          this.initDepartment();
        }
      }); */
        this.getDepartment(val.val);
      },
      async getDepartment(companyCode) {
        // 部门
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this.slipDepartmentList = res;
          }
        } else {
          this.slipDepartmentList = [];
        }
      },
      // 获取当前登录用户所在的公司部门
      async getCurrentDepartment() {
        let personDepartmentInfo = [];
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };

        await this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            personDepartmentInfo = res.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });

            this.query.recipientsDepartmentCode = personDepartmentInfo[0].value;
            this.slipDepartmentList = personDepartmentInfo;
          }
        });
        //this.getData();
      },
      //业务部门
      /* initDepartment(val) {
      this.$axios
        .post(
          DataBaseAPI.LIST_DEPARTMENT_API +
            "/" +
            this.query.recipientsCompanyCode
        )
        .then(res => {
          if (0 == res.data.code) {
            this.slipDepartmentList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
    }, */
      // 切换商品大类 获取商品编号
      async changeGoodsType(val) {
        this.productDetailList = [];
        this.query.productCode = '';
        const selectStatus = await this.$axios.get(API.COLLARDETAILS_PRODUCTCODE_API, {
          productType: val.val,
        });
        if (selectStatus.data.code == 0) {
          this.productDetailList = selectStatus.data.data;
        }
      },
      projectChange() {
        // 切换项目
        this.query.periodCode = this.query.periodName = null;
      },
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.periodCode = res[0].periodCode;
          this.query.periodName = res[0].periodName;
        } else {
          this.query.periodCode = this.query.periodName = null;
        }
        if (res[0].periodStatus == 'closed') {
          //关闭的账期不能对数据进行增删改
          this.menuButtonList.forEach((item) => {
            if (['del'].indexOf(item.attributes.buttonUrl) > -1) {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else {
          this.menuButtonList.forEach((item) => {
            item.isDisabled = false;
          });
        }
      },
      // 按钮
      chooseClick(type) {
        if (type === 'add') {
          let path = {
            path: '/production/collarAdd',
            name: 'collarAdd',
            meta: {
              keepAlive: true,
              title: '新增领用明细',
            },
            query: {},
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type === 'importData') {
          //批量导入
          this.dialogAdd = true;
        } else if (type === 'del') {
          //批量删除
          this.handleDelete();
        } else if (type === 'export') {
          if (this.tableData && this.tableData.length === 0) {
            return this.tips('noExport');
          }
          this.handleExport();
        } else if (type === 'linkToCostDetails') {
          //查看耗用情况表
          let path = {
            path: '/production/costDetailsList',
            name: 'costDetailsList',
            meta: {
              keepAlive: false,
              title: '原辅料耗用明细',
            },
            query: {},
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
      // 表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'projectCode') {
          this.baseData.periodCode = this.baseData.periodName = null;
          this.baseData.projectCode = value.projectCode;
          this.baseData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }
        if (prop == 'periodName') {
          let res = value.periodName;
          if (res && res.length > 0) {
            this.baseData.projectCode = res[0].projectCode;
            this.baseData.projectName = res[0].projectName;
            this.baseData.periodCode = res[0].periodCode;
            this.baseData.periodName = res[0].periodName;
          } else {
            this.baseData.periodCode = this.baseData.periodName = null;
          }
        }
      },
      //列表双击p
      dblclickEvent(value) {
        console.log(value.row);
        /* let path = {
        path: "/production/collarDetails",
        name: "collarDetails",
        meta: {
          keepAlive: false,
          title: "领用明细详情"
        },
        query: {}
      };
      this.$store.dispatch("tagsView/addTabView", path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      }); */
      },
      // 设置导入配置
      setImport() {
        this.importUrl = API.COLLARDETAILS_IMPORT_API;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        let recipientsCompanyCode = this.userInfo.companyCode; //公司信息
        let recipientsCompanyName = this.userInfo.companyName; //公司信息
        let recipientsDepartmentCode = this.userInfo.departmentCode; //部门信息
        let recipientsDepartmentName = this.userInfo.departmentCode; //部门信息
        let createPersonNo = this.userInfo.userCode; //操作人
        let createPersonName = this.userInfo.userName; //操作人
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          recipientsCompanyCode,
          recipientsCompanyName,
          recipientsDepartmentCode,
          recipientsDepartmentName,
          createPersonNo,
          createPersonName,
          productClass: '0',
        };
      },
      // 返回表单数据
      exportBaseData() {
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      // 批量导入
      handleImport() {
        let baseData = this.exportBaseData();
        if (baseData) {
          this.importData = Object.assign(this.importData, this.baseData);
          this.$refs.siruiUpload.openDialog(true);
          this.dialogAdd = false;
        }
      },
      //删除
      handleDelete() {
        if (this.multipleSelection.length == 0) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('message.noData'),
          });
        }

        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.COLLARDETAILS_DELETE_API, ids).then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('collarDetailsList.message.deleteSuccess'),
                  type: 'success',
                });
                this.multipleSelection = [];
                this.$refs.siruiTable.clearCheckboxRow();
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      /* // 导出
    handleExport() {
      let tableColumn = this.$refs.siruiTable.getTableColumn().visibleColumn;
      let showColumns = [];
      let idList = [];
      tableColumn.forEach(item => {
        if (item.property) showColumns.push({ prop: item.property });
      });
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach(item => {
          idList.push(item.supplierCode);
        });
      }
      // const { tenantCode, companyCode, departmentCode } = this.userInfo;
      // let params = { tenantCode, companyCode, departmentCode };
      let params = {};
      params = Object.assign(params, this.query);
      params.columns = showColumns;
      params.ids = idList;
      this.$axios.post(collarAPI.COLLARDETAILS_EXPORT_API, params).then(res => {
        if (res.data.code === 0) {
          window.location.href = res.data.data;
        }
      });
    }, */
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'idList=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.COLLARDETAILS_EXPORT_API}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${API.COLLARDETAILS_EXPORT_API}?${params}&access_token=${this.token.access_token}`;
        }
      },
      //提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`collarDetailsList.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
<style scoped>
  .el-row {
    margin-bottom: 10px;
    font-size: 12px;
    text-align: right;
    vertical-align: middle;
    color: #606266;
  }
  .el-col {
    border-radius: 4px;
    line-height: 32px;
  }
  .grid-content {
    padding: 0 12px 0 0 !important;
  }
</style>
